import { FilteredOptionsInterface, makeQueryParamsForRequest } from '../entities/FilteredOptions';
import http from '../helpers/http';

const TimeCard = (token: string) => {
  const headers = {
    'x-access-token': token,
  };

  return {
    list: async (schoolId: string, filteredOptions?: FilteredOptionsInterface) => {
      const params = makeQueryParamsForRequest(filteredOptions);
      const result = await http.get(`/timecards/${schoolId}`, {
        headers,
        params,
      });
      return result.data;
    },
    reviewApprove: async (id: string) => {
      const result = await http.patch(
        `/timecards/${id}/review-approve`,
        {},
        {
          headers,
        },
      );
      return result.data;
    },
    reviewReject: async (id: string) => {
      const result = await http.patch(
        `/timecards/${id}/review-reject`,
        {},
        {
          headers,
        },
      );
      return result.data;
    },
  };
};

export default TimeCard;
